module.exports = __webpack_public_path__ + "static/media/LK_Internet Disconnected.e2c5febb.svg";